module.exports = __webpack_public_path__ + "img/result_icon_02.a200ecc1.jpg";